import type { TypographyProps } from '@twistopayments/design-system/components/atoms/typography'
import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import { useHighlightedText } from 'homepage/libs/hooks'

import * as styles from './highlighted-title.styles'

type Props = {
  title?: string
  highlighted?: string
}
export const HighlightedTitle = ({
  title,
  highlighted,
  ...other
}: Props & TypographyProps) => {
  const { before, after, highlight } = useHighlightedText(title, highlighted)

  return (
    <Typography css={styles.title} fontWeight="heavy" variant="h2" {...other}>
      {before}
      <span css={styles.highlighted}>{highlight}</span>
      {after}
    </Typography>
  )
}
